import React from "react"
import { Link } from "gatsby"
import Layout from "./layout"

export default ({ data }) => {
  const [showPreviousCourses, setShowPreviousCourses] = React.useState(false)

  return (
    //npm run build:skip-b
    <Layout>
      <div className="list-plain landing">
        <ul>
          <li>
            <h5>Fall 2026 Courses @ RISD</h5>
            <p>Typography 1<br />
              with Anastasiia Raina, Brockett Horne, Livia Foldes, and Lobbin Liu</p>
            <p>Typography 2<br />
              with Ernesto Aparicio, Franz Werner, and Kelsey Elder</p>
            <p><Link to="/wam1f26/">Web as Medium 1</Link></p>
            </li>
        </ul>
        <h5>
          <button
            type="button"
            aria-expanded={showPreviousCourses}
            aria-controls="previous-courses"
            onClick={() => setShowPreviousCourses(!showPreviousCourses)}
          >
            Previous courses
          </button>
        </h5>
        {showPreviousCourses && <ul id="previous-courses">
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2026 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Typography 2<br />
              with Cara Buzzell, Ernesto Aparicio, Elizabeth Leeper, Lobbin Liu, and Kelsey Elder</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2025 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Web as Medium 1</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Intro to Computation</span><br />
              <span class="MuiListItem-root Mui-disabled">with Mattia Casalegno and Clement Valla</span></p>
            </li>
            <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2025 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Web as Medium 2</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Typography II<br />
              with Anastasiia Raina, Ernesto Aparicio, Franz Werner, and Laura Coombs</span></p>
            </li>
        <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2024 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Web as Medium 1</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Typography I<br />
              with Ernesto Aparicio, Franz Werner, Martha Kang McGill, and Min Hee Lee</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2024 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Design Studio 4<br />
              with Anther Kiley, Hammett Nurosi, and Tom Wedell</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Web as Medium</span></p>
          </li>
         
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2023 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Typography I<br />
              with Ernesto Aparicio, Dylan Fracareta, Min Hee Lee, and Emily Rye</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2022 (Nov 1) Workshop @ Rice</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Form and Machine</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall  2022 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Interdisciplinary Critique</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Summer 2022 Courses @ Cortona UGA</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Special Problems in Design <br />
              with Moon Jang</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Graphic Design in Field Study <br />
              with Moon Jang</span>
            </p>
          </li>
          {/* <li>
          <h5>Summer 2022 Courses @ Cortona UGA</h5>
          <p><a herf="https://classroom.google.com/u/0/c/NTE1MjcxMDkzNzU4">Special Problems in Design</a> <br/>
            with Moon Jung Jang</p> 
          <p> <a href="https://classroom.google.com/u/0/c/NTE1MjcxMDkzOTky">Graphic Design Field Study</a> <br/>
            with Moon Jung Jang</p> 
        </li> */}

          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2022 Courses @ RISD</span></h5>
            <p>
              <span class="MuiListItem-root Mui-disabled">Code Lab<br />
                Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span>
            </p>
            <p>
              <span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3 <br />
                with Kelsey Elder, Hammett Nurosi, Rene Payne, Anastasiia Raina, and Tom Wedell</span>
            </p>
            <p>
              <span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span>
            </p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2022 (Feb 15) Workshop @ UGA</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">CSS Motion</span></p>
          </li>
          {/* <li>
          <h5>Spring 2022 Courses @ RISD</h5>
          <p><a href="http://risdcodelab.org/">Code Lab</a><br/>
            Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</p>
          <p>Design Studio 4, section 3 <br/>
            with Kelsey Elder, Hammett Nurosi, Rene Payne, Anastasiia Raina, and Tom Wedell
          </p>
          <p><Link to="/gdtsns22/">Generative Design: Tool, System, Network</Link></p>        </li>
        <li>
          <h5><span class="MuiListItem-root Mui-disabled">Spring 2022 (Feb 15) Workshop @ UGA</span></h5>
          <p><span class="MuiListItem-root Mui-disabled">CSS Motion</span></p> 
        </li> */}
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2021 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Design Studio 1, section 2<br />
              with Kelsey Dusenka, Shiraz Gallab, Anther Kiley, and Nancy Skolos</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Typography III, section 5<br />
              with Kelsey Dusenka, Shiraz Gallab, Hammett Nurosi, and Ramon Tejada</span></p>
            {/* <p><a href="http://ds2123.risd.gd">Design Studio 1</a>, section 2<br/>
          with Kelsey Dusenka, Shiraz Gallab, Anther Kiley, and Nancy Skolos</p>
          <p><Link to="/gdfwf21/">Graphic Design for the Web</Link></p>
          <p><Link to="/t3f21/">Typography III</Link>, section 5<br/>
           with Kelsey Dusenka, Shiraz Gallab, Hammett Nurosi, and Ramon Tejada</p>  */}
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2021 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Code Lab<br />
              Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3<br />
              with Cara Buzzell, Kelsey Elder, and Tom Wedell</span>
            </p>
            <p><span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span></p>
            {/* <p><a href="http://ds2123.risd.gd">Design Studio 1</a>, section 2<br/>
          with Kelsey Dusenka, Shiraz Gallab, Anther Kiley, and Nancy Skolos</p>
          <p><Link to="/gdfwf21/">Graphic Design for the Web</Link></p>
          <p><Link to="/t3f21/">Typography III</Link>, section 5<br/>
           with Kelsey Dusenka, Shiraz Gallab, Hammett Nurosi, and Ramon Tejada</p> 
        </li>
        <li>
          <h5><span class="MuiListItem-root Mui-disabled">Spring 2021 Courses @ RISD</span></h5>
          <p><span class="MuiListItem-root Mui-disabled">Code Lab<br/>
            Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span></p>
          <p><span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3<br/>
            with Cara Buzzell, Kelsey Elder, and Tom Wedell</span> 
          </p>
          <p><span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span></p> */}
            {/*  <p><a href="https://github.com/RISD-Code-Lab/spring2021">Code Lab</a><br/>
            Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</p>
          <p><a href="https://docs.google.com/document/d/1WVer4Rjc4bjaaYnjGVajvkNxvto5heTGjKGoP1sBceE/edit?usp=sharing">Design Studio 4</a>, section 3 <br/>
            with Cara Buzzell, Kelsey Elder, and Tom Wedell
          </p>
          <p><Link to="/gdtsns21/">Generative Design: Tool, System, Network</Link></p> */}
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2020 Courses @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Design Studio 1, section 2<br />
              with Kelsey Dusenka, Anther Kiley, Anastasiia Raina, and Nancy Skolos</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Typography III, section 5<br />
              with James Goggin, Jacek Mrowczyk, Nancy Skolos, and Ramon Tejada</span></p>
            {/* <p><a href="http://ds2022.risd.gd">Design Studio 1</a>, section 2<br/>
          Curriculum developed with Kelsey Dusenka, Anther Kiley, Anastasiia Raina, and Nancy Skolos</p>
          <p><Link to="/gdfwf20/">Graphic Design for the Web</Link></p>
          <p><Link to="/b-t3f20/">Typography III</Link>, section 5<br/>
          Lecture series developed with James Goggin, Jacek Mrowczyk, Nancy Skolos, and Ramon Tejada</p>  */}
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2020 Courses @ RISD</span></h5>
            {/* <p><a href="http://risdcodelab.org/">Code Lab</a><br/>
            Co-initiated/taught with Marie Otsuka and Nic Schumann</p>
          <p><a href="http://ds1820.risd.gd">Design Studio 4</a>, section 3 <br/>
            Curriculum developed with Cara Buzzell, Kelsey Elder, Anastasiia Raina, and Tom Wedell 
          </p>
          <p><Link to="/gdtsns20/">Generative Design: Tool, System, Network</Link></p> */}
            <p><span class="MuiListItem-root Mui-disabled">Code Lab<br />
              {/* Extracurricular lab sessions to develop foundational code literacy  */}
              Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3 <br />
              with Cara Buzzell, Kelsey Elder, Anastasiia Raina, and Tom Wedell </span>
            </p>
            <p><span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2019 Courses @ RISD</span></h5>
            {/* <p><a href="http://ds1921.risd.gd">Design Studio 1</a></p>
          <p><Link to="/gdfwf19/">Graphic Design for the Web</Link></p>
          <p><Link to="/t3f19/">Typography III</Link></p> */}
            <p><span class="MuiListItem-root Mui-disabled">Design Studio 1, section 2<br />
              with Anther Kiley, Anastasiia Raina, and Nancy Skolos</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
            <p><span class="MuiListItem-root Mui-disabled">Typography III, section 5<br />
              with James Goggin, Jacek Mrowczyk, Nancy Skolos, and Ramon Tejada</span>
            </p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2019 Course @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Fall 2018 (Oct 25–27) Workshop @ CCA</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Repetition and Variables</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Spring 2016 Course @ Parsons</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Web Design Basics</span></p>
          </li>
          <li>
            <h5><span class="MuiListItem-root Mui-disabled">Winter 2015 Course @ RISD</span></h5>
            <p><span class="MuiListItem-root Mui-disabled">Modes of Self-Publishing<br />Co-initiated with Christina Webb</span></p>
            {/* <a href="http://christinawebb.org/?p=352" target="blank"></a> */}
          </li>
        </ul>}
        <div style={{ paddingTop: `0.5rem`, borderTop: 'solid 1px' }}>
          Teaching portal of <a href="http://minkyoungkim.com">Minkyoung Kim</a> © 2015–{new Date().getFullYear()}
        </div>
      </div>
    </Layout>
  )
}

// import { Link } from "gatsby"
// import Layout from "./layout"

// import Collapse from '@material-ui/core/Collapse'
// import List from '@material-ui/core/List'
// import ListItem from '@material-ui/core/ListItem'
// import ListItemText from '@material-ui/core/ListItemText'

// const IndexPage = ({ data }) => {

//   const [prev, showSchedule1] = React.useState(true)
//   const [current, showSchedule2] = React.useState(false) 


//     function handleClick1(id) {
//     switch (id) {
//       case "prev":
//         showSchedule1(!prev)
//         break;
//     }
//      switch (id) {
//         case "current":
//          showSchedule2(!current)
//         break;
//     }
//   }



//  return (
//     <Layout>
//       <div className="list-class landing">
//         <ListItem id='current' className="accordion" button onClick={() => handleClick1("currentv")}>
//           <ListItemText primary='' className="accordion-heading  maxw-30" /> Current Semester
//         </ListItem>
//           <Collapse in={!current} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>
//               <ul>
//           <li>
//             <h5>Fall 2025 Courses @ RISD</h5>
//             <p><Link to="/wam1f25/">Web as Medium 1</Link></p>
//             <p>Intro to Computation<br />
//               with Mattia Casalegno and Clement Valla</p>
//             </li>
//           </ul>
//           </List>
//           </Collapse>
   
      
//         <ListItem id='prev' className="accordion" button onClick={() => handleClick1("prev")}>
//           <ListItemText primary='' className="accordion-heading  maxw-30" /> Previous Semesters
//         </ListItem>
//          <Collapse in={!prev} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>

//             <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2025 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Web as Medium 2</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Typography II<br />
//               with Anastasiia Raina, Ernesto Aparicio, Franz Werner, and Laura Coombs</span></p>
//             </li>
//         <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall 2024 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Web as Medium 1</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Typography I<br />
//               with Ernesto Aparicio, Franz Werner, Martha Kang McGill, and Min Hee Lee</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2024 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Design Studio 4<br />
//               with Anther Kiley, Hammett Nurosi, and Tom Wedell</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Web as Medium</span></p>
//           </li>
         
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall 2023 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Typography I<br />
//               with Ernesto Aparicio, Dylan Fracareta, Min Hee Lee, and Emily Rye</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall 2022 (Nov 1) Workshop @ Rice</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Form and Machine</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall  2022 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Interdisciplinary Critique</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Summer 2022 Courses @ Cortona UGA</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Special Problems in Design <br />
//               with Moon Jang</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Graphic Design in Field Study <br />
//               with Moon Jang</span>
//             </p>
//           </li>
//           {/* <li>
//           <h5>Summer 2022 Courses @ Cortona UGA</h5>
//           <p><a herf="https://classroom.google.com/u/0/c/NTE1MjcxMDkzNzU4">Special Problems in Design</a> <br/>
//             with Moon Jung Jang</p> 
//           <p> <a href="https://classroom.google.com/u/0/c/NTE1MjcxMDkzOTky">Graphic Design Field Study</a> <br/>
//             with Moon Jung Jang</p> 
//         </li> */}

//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2022 Courses @ RISD</span></h5>
//             <p>
//               <span class="MuiListItem-root Mui-disabled">Code Lab<br />
//                 Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span>
//             </p>
//             <p>
//               <span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3 <br />
//                 with Kelsey Elder, Hammett Nurosi, Rene Payne, Anastasiia Raina, and Tom Wedell</span>
//             </p>
//             <p>
//               <span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span>
//             </p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2022 (Feb 15) Workshop @ UGA</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">CSS Motion</span></p>
//           </li>
//           {/* <li>
//           <h5>Spring 2022 Courses @ RISD</h5>
//           <p><a href="http://risdcodelab.org/">Code Lab</a><br/>
//             Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</p>
//           <p>Design Studio 4, section 3 <br/>
//             with Kelsey Elder, Hammett Nurosi, Rene Payne, Anastasiia Raina, and Tom Wedell
//           </p>
//           <p><Link to="/gdtsns22/">Generative Design: Tool, System, Network</Link></p>        </li>
//         <li>
//           <h5><span class="MuiListItem-root Mui-disabled">Spring 2022 (Feb 15) Workshop @ UGA</span></h5>
//           <p><span class="MuiListItem-root Mui-disabled">CSS Motion</span></p> 
//         </li> */}
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall 2021 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Design Studio 1, section 2<br />
//               with Kelsey Dusenka, Shiraz Gallab, Anther Kiley, and Nancy Skolos</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Typography III, section 5<br />
//               with Kelsey Dusenka, Shiraz Gallab, Hammett Nurosi, and Ramon Tejada</span></p>
//             {/* <p><a href="http://ds2123.risd.gd">Design Studio 1</a>, section 2<br/>
//           with Kelsey Dusenka, Shiraz Gallab, Anther Kiley, and Nancy Skolos</p>
//           <p><Link to="/gdfwf21/">Graphic Design for the Web</Link></p>
//           <p><Link to="/t3f21/">Typography III</Link>, section 5<br/>
//            with Kelsey Dusenka, Shiraz Gallab, Hammett Nurosi, and Ramon Tejada</p>  */}
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2021 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Code Lab<br />
//               Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3<br />
//               with Cara Buzzell, Kelsey Elder, and Tom Wedell</span>
//             </p>
//             <p><span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span></p>
//             {/* <p><a href="http://ds2123.risd.gd">Design Studio 1</a>, section 2<br/>
//           with Kelsey Dusenka, Shiraz Gallab, Anther Kiley, and Nancy Skolos</p>
//           <p><Link to="/gdfwf21/">Graphic Design for the Web</Link></p>
//           <p><Link to="/t3f21/">Typography III</Link>, section 5<br/>
//            with Kelsey Dusenka, Shiraz Gallab, Hammett Nurosi, and Ramon Tejada</p> 
//         </li>
//         <li>
//           <h5><span class="MuiListItem-root Mui-disabled">Spring 2021 Courses @ RISD</span></h5>
//           <p><span class="MuiListItem-root Mui-disabled">Code Lab<br/>
//             Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span></p>
//           <p><span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3<br/>
//             with Cara Buzzell, Kelsey Elder, and Tom Wedell</span> 
//           </p>
//           <p><span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span></p> */}
//             {/*  <p><a href="https://github.com/RISD-Code-Lab/spring2021">Code Lab</a><br/>
//             Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</p>
//           <p><a href="https://docs.google.com/document/d/1WVer4Rjc4bjaaYnjGVajvkNxvto5heTGjKGoP1sBceE/edit?usp=sharing">Design Studio 4</a>, section 3 <br/>
//             with Cara Buzzell, Kelsey Elder, and Tom Wedell
//           </p>
//           <p><Link to="/gdtsns21/">Generative Design: Tool, System, Network</Link></p> */}
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall 2020 Courses @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Design Studio 1, section 2<br />
//               with Kelsey Dusenka, Anther Kiley, Anastasiia Raina, and Nancy Skolos</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Typography III, section 5<br />
//               with James Goggin, Jacek Mrowczyk, Nancy Skolos, and Ramon Tejada</span></p>
//             {/* <p><a href="http://ds2022.risd.gd">Design Studio 1</a>, section 2<br/>
//           Curriculum developed with Kelsey Dusenka, Anther Kiley, Anastasiia Raina, and Nancy Skolos</p>
//           <p><Link to="/gdfwf20/">Graphic Design for the Web</Link></p>
//           <p><Link to="/b-t3f20/">Typography III</Link>, section 5<br/>
//           Lecture series developed with James Goggin, Jacek Mrowczyk, Nancy Skolos, and Ramon Tejada</p>  */}
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2020 Courses @ RISD</span></h5>
//             {/* <p><a href="http://risdcodelab.org/">Code Lab</a><br/>
//             Co-initiated/taught with Marie Otsuka and Nic Schumann</p>
//           <p><a href="http://ds1820.risd.gd">Design Studio 4</a>, section 3 <br/>
//             Curriculum developed with Cara Buzzell, Kelsey Elder, Anastasiia Raina, and Tom Wedell 
//           </p>
//           <p><Link to="/gdtsns20/">Generative Design: Tool, System, Network</Link></p> */}
//             <p><span class="MuiListItem-root Mui-disabled">Code Lab<br />
//               {/* Extracurricular lab sessions to develop foundational code literacy  */}
//               Extracurricular lab sessions co-initiated with Marie Otsuka and Nic Schumann</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Design Studio 4, section 3 <br />
//               with Cara Buzzell, Kelsey Elder, Anastasiia Raina, and Tom Wedell </span>
//             </p>
//             <p><span class="MuiListItem-root Mui-disabled">Generative Design: Tool, System, Network</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall 2019 Courses @ RISD</span></h5>
//             {/* <p><a href="http://ds1921.risd.gd">Design Studio 1</a></p>
//           <p><Link to="/gdfwf19/">Graphic Design for the Web</Link></p>
//           <p><Link to="/t3f19/">Typography III</Link></p> */}
//             <p><span class="MuiListItem-root Mui-disabled">Design Studio 1, section 2<br />
//               with Anther Kiley, Anastasiia Raina, and Nancy Skolos</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
//             <p><span class="MuiListItem-root Mui-disabled">Typography III, section 5<br />
//               with James Goggin, Jacek Mrowczyk, Nancy Skolos, and Ramon Tejada</span>
//             </p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2019 Course @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Graphic Design for the Web</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Fall 2018 (Oct 25–27) Workshop @ CCA</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Repetition and Variables</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Spring 2016 Course @ Parsons</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Web Design Basics</span></p>
//           </li>
//           <li>
//             <h5><span class="MuiListItem-root Mui-disabled">Winter 2015 Course @ RISD</span></h5>
//             <p><span class="MuiListItem-root Mui-disabled">Modes of Self-Publishing<br />Co-initiated with Christina Webb</span></p>
//             {/* <a href="http://christinawebb.org/?p=352" target="blank"></a> */}
//           </li>

//           </List>
//           </Collapse>
       
      
//         <div style={{ paddingTop: `0.5rem`, borderTop: 'solid 1px' }}>
//           Teaching portal of <a href="http://minkyoungkim.com">Minkyoung Kim</a> © 2015–{new Date().getFullYear()}
//         </div>
//       </div>
//     </Layout>
//   )
  
// }

// export default IndexPage
